import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const BlogRedirect = ({ blogData }) => {
  const { slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!slug || !blogData) {
      navigate('/blog', { replace: true });
      return;
    }

    // Function to normalize slugs for comparison
    const normalizeSlug = (str) => {
      return str.toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '') // Remove special characters except spaces and hyphens
        .replace(/\s+/g, '-') // Replace spaces with hyphens
        .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
        .trim();
    };

    // Function to create multiple variations of a slug for matching
    const createSlugVariations = (inputSlug) => {
      const normalized = normalizeSlug(inputSlug);
      return [
        normalized,
        inputSlug.toLowerCase(),
        inputSlug,
        // Remove common prefixes/suffixes that might have been added
        normalized.replace(/^(the-|a-|an-)/, ''),
        normalized.replace(/(-blog|-post|-article)$/, ''),
      ].filter(Boolean);
    };

    // Try to find a matching blog post
    const findMatchingBlog = (searchSlug) => {
      const searchVariations = createSlugVariations(searchSlug);
      
      return blogData.find(blog => {
        const blogSlugVariations = createSlugVariations(blog.slug);
        
        // Check for exact matches first
        for (const searchVar of searchVariations) {
          for (const blogVar of blogSlugVariations) {
            if (searchVar === blogVar) {
              return true;
            }
          }
        }
        
        // Check for partial matches (if one contains the other)
        for (const searchVar of searchVariations) {
          for (const blogVar of blogSlugVariations) {
            if (searchVar.length > 10 && blogVar.includes(searchVar)) {
              return true;
            }
            if (blogVar.length > 10 && searchVar.includes(blogVar)) {
              return true;
            }
          }
        }
        
        return false;
      });
    };

    const matchedBlog = findMatchingBlog(slug);
    
    if (matchedBlog) {
      // Redirect to the correct blog post
      navigate(`/blog/${matchedBlog.slug}`, { replace: true });
    } else {
      // If no match found, redirect to blog index
      console.warn(`No matching blog found for slug: ${slug}`);
      navigate('/blog', { replace: true });
    }
  }, [slug, blogData, navigate]);

  // Show loading or nothing while redirecting
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '50vh',
      fontSize: '18px'
    }}>
      Redirecting...
    </div>
  );
};

export default BlogRedirect;